import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import DashboardLayout from "../components/DashboardLayout";
import Login from "../components/Login";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";
import RestaurantTracker from "../components/RestaurantTracker";
import User from "../components/User";
import Booking from "../components/Booking";
import Payment from "../components/Payment";
import Banners from "../components/Banners";
import SuperAdminDashboard from "../components/SuperAdminDashboard";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="restaurant-tracker" element={<RestaurantTracker />} />
        <Route path="users" element={<User />} />
        <Route path="bookings" element={<Booking />} />
        <Route path="payments" element={<Payment />} />
        <Route path="banners" element={<Banners />} />
        <Route path="dashboard" element={<SuperAdminDashboard />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
